import { client } from '@atlassian/rovo-content-bridge-api';

export const ROVO_EXPERIENCE_TRACKING_SENDER_CLIENT_ID = client('rovo-experience-tracking-sender');
